// extracted by mini-css-extract-plugin
export default {"btn":"not-found-page_btn__h5vyQ","container":"not-found-page_container__cw1gk"};